import React, { useEffect, useRef, createContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout, loadCredentials } from 'src/redux/slices/auth';
import { setSocketAuth, resetSocketState } from 'src/redux/slices/socketStates';
import { useOverlay } from './OverlayContext';
import { Typography, Button } from '@material-ui/core';
import { selectBIZ } from 'src/redux/slices/auth';
import { persistor, store } from 'src/redux/store';
const shouldShowOverlay = (target, currentUser) => {
  if (window.location.pathname.startsWith('/portal/')) return false;
  if (target === 'all') return true;
  if (target === 'ru') return currentUser.ru === 1;
  if (target === 'users') return currentUser.ru !== 1;
  if (target === 'none') return false;
  return false; // safety fallback
};

const BroadCastContext = createContext(null);

const BroadCastProvider = ({ children }) => {
  const channelRef = useRef(new BroadcastChannel('general'));
  const tabId = useRef(`${Date.now()}-${Math.random()}`);
  const { setOverlay } = useOverlay();
  const dispatch = useDispatch();
  const current_user = useSelector(state => state.auth.current_user);
  const ixBiz = useSelector(state => state.auth.ixBiz);
  const currentUserRef = useRef(current_user);
  const { bizList = [] } = useSelector(state => state.registry);

  function bizInfo({ ixBiz }) {
    const bizListCopy = [...bizList];
    const indx = bizListCopy.findIndex(data => data.ixBiz === ixBiz);
    return bizListCopy[indx];
  }
  useEffect(() => {
    currentUserRef.current = current_user;
  }, [current_user]);

  //functions for listeners
  const LISTENERS = {
    login: data => {
      if (window.location.pathname.startsWith('/portal/')) return false;
      dispatch(setSocketAuth(data));
      dispatch(loadCredentials(data));
    },
    logout: data => {
      if (window.location.pathname.startsWith('/portal/')) return false;
      dispatch(resetSocketState());
      dispatch(logout());
    },
    selectBiz: async data => {
      const target = data?.target ?? 'none'; // default to all
      if (shouldShowOverlay(target, currentUserRef.current)) {
        setOverlay({
          open: true,
          component: (() => {
            const AutoReloadInline = () => {
              const [secondsLeft, setSecondsLeft] = React.useState(5);

              React.useEffect(() => {
                const interval = setInterval(() => {
                  setSecondsLeft(prev => {
                    if (prev <= 1) {
                      clearInterval(interval);
                      window.location.reload();
                      return 0;
                    }
                    return prev - 1;
                  });
                }, 1000);

                return () => clearInterval(interval);
              }, []);

              return (
                <React.Fragment>
                  <Typography variant="h2" style={{ whiteSpace: 'pre-wrap' }}>
                    {data?.text ??
                      `Active Biz has been switched\nReloading in ${secondsLeft} seconds...`}
                  </Typography>
                  <Button
                    fullWidth
                    variant="contained"
                    style={{
                      marginTop: 16,
                      backgroundColor: '#FF7504',
                      color: '#fff'
                    }}
                    onClick={() => window.location.reload()}
                  >
                    Reload Now
                  </Button>
                </React.Fragment>
              );
            };
            return <AutoReloadInline />;
          })(),
          style: {
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }
        });
      }
    },
    reload: async data => {
      window.location.reload();
    }
  };

  useEffect(() => {
    const channel = channelRef.current;

    channel.onmessage = event => {
      const { type, source, ...data } = event.data;
      if (source === tabId.current) return;
      const handler = LISTENERS[type];

      if (handler) {
        handler(data);
      }
    };

    return () => {
      channel.close();
    };
  }, [dispatch]);

  return (
    <BroadCastContext.Provider
      value={{
        channel: channelRef.current,
        tabId: tabId.current
      }}
    >
      {children}
    </BroadCastContext.Provider>
  );
};

export default BroadCastContext;
export { BroadCastProvider };
